<template>
  <div>
    <p :class="pClass">
      <label v-if="!logo || forceTitle">{{ labelTitle }}</label>
      <label :for="`input-${_uid}`" :class="labelClass" :title="text">
        <span>
          <img v-if="getImageLink && !deleting" :src="getImageLink" alt="addImg" />
        </span>
        <a
            class="btn btn_action btn_delete"
            v-if="getImageLink && !logo"
            @click.prevent="onButtonRemoveClick"
            title="Smazat"
        >Smazat</a>
      </label>

      <span v-if="imageParams" :class="spanClass">
        {{ imageParams.dimensions.width }} x {{ imageParams.dimensions.height }} px<br />
        {{ Math.round(imageParams.size / 1000) }} kB<br />
        <translate>Poměr</translate>: {{ +(imageParams.dimensions.width / imageParams.dimensions.height).toFixed(1) }}<br />
      </span>
      <span v-else-if="image && !shouldRemoveOriginal" :class="spanClass">
        {{ image.dimensions }}<br />
        {{ Math.round(image.size / 1000) }} kB<br />
        <translate>Poměr</translate>: {{ +(image.ratio).toFixed(1) }}<br />
      </span>

      <label v-if="logo" :for="`input-${_uid}`" class="add_profile_image">
        <span v-translate>Nahrát logo</span>
        <input
            :id="`input-${_uid}`"
            :name="name"
            :disabled="disabled"
            type="file"
            accept="image/*"
            ref="fileInput"
            @change="onFileChanged"
        >
        <input type="hidden" :name="name + '$id'" :value="image._id" v-if="image && !shouldRemoveOriginal" />
      </label>

      <span v-if="!logo" class="profile_image_box">
        <input
            :id="`input-${_uid}`"
            :name="name"
            :disabled="disabled"
            type="file"
            accept="image/*"
            ref="fileInput"
            @change="onFileChanged"
        >
        <label :for="`input-${_uid}`" class="add_profile_image">
          <span>{{ text }}</span>
        </label>
      </span>

      <a
          class="btn btn_action btn_delete"
          v-if="getImageLink && logo"
          @click.prevent="onButtonRemoveClick"
          title="Smazat"
      >Smazat</a>
    </p>
  </div>
</template>

<script>
export default {
  name: 'app-image-input',
  props: {
    forceTitle: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: 'Obrázek'
    },
    text: {
      type: String,
      default: 'Nahrát obrázek'
    },
    name: {
      type: String,
      default: null
    },
    image: {
      type: Object,
      default: null
    },
    imageLink: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    verticalLayout: {
      type: Boolean,
      default: false
    },
    pClass: {
      type: String,
      default: ''
    },
    labelClass: {
      type: String,
      default: ''
    },
    spanClass: {
      type: String,
      default: ''
    },
    labelTitle: {
      type: String,
      default: ''
    },
    logo: {
      type: Boolean,
      default: false
    },
    deleting: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      imagePreview: null,
      imageParams: null,
      shouldRemoveOriginal: false
    }
  },
  computed: {
    wrapperClass() {
      return {
        'image-input-disabled': this.disabled,
        'image-input-error': this.error
      }
    },
    getImageLink() {
      if (this.imagePreview) {
        return this.imagePreview
      }
      if (this.imageLink) {
        return this.imageLink
      }
      return null
    }
  },
  methods: {
    onFileChanged(event) {
      const file = event.target.files[0]

      if (!file || !file.type.match(/^image\//) || file.size > (2 * 1024 * 1024)) {
        console.error('Image fail because of size/type')
        return
      }

      this.imageParams = {
        name: file.name,
        size: file.size,
        dimensions: {}
      }

      const fileReader = new FileReader()
      fileReader.onload = (e) => {
        this.imagePreview = e.target.result
        this.shouldRemoveOriginal = true

        const image = new Image()
        image.src = this.imagePreview
        image.onload = () => {
          this.imageParams.dimensions = {
            width: image.width,
            height: image.height
          }
        }
      }

      fileReader.readAsDataURL(file)
      this.$emit('fileChanged')
    },
    onButtonRemoveClick() {
      this.shouldRemoveOriginal = true
      this.imagePreview = null
      this.imageParams = null
      this.$refs.fileInput.value = ''
      this.$emit('fileChanged')
    }
  },
  watch: {
    image(v) {
      if (!v) {
        this.onButtonRemoveClick()
      }
      this.shouldRemoveOriginal = false
    }
  }
}
</script>
